import { FC } from 'react';
import { useSelector } from 'react-redux';
import { FullWidth } from 'ui/utility/fullWidth';
import { HeaderGridRow } from 'ui/indexPages/tables/grid';
import { PaginationFooter, PaginationUpdateEvent } from 'ui/paginationFooter';
import { TABLE_GRID } from '../constants';
import { useQueryContext } from '../context';
import { selectMetaData, selectViews } from '../redux/selectors';
import { SavedViewsTableFilters as TableFilters } from './SavedViewsTableFilters';
import { EmptyState } from './tableComponents/EmptyState';
import { GroupSelectCell } from './tableComponents/GroupSelectCell';
import { HeaderCell } from './tableComponents/HeaderCell';
import { ViewRow } from './tableComponents/ViewRow';

export const TABLE_COLS = [
  {
    label: 'Name',
    value: 'name',
  },
  {
    label: 'Description',
    value: 'description',
  },
  {
    label: 'Last modified',
    value: 'updatedAt',
  },
];

export const SavedViewsTable: FC = () => {
  const { pageSize: size, setPageSize, currentPage, setCurrentPage } = useQueryContext();

  const views = useSelector(selectViews);
  const { totalCount } = useSelector(selectMetaData) || {};

  const handlePaginationUpdate = ({ page, pageSize }: PaginationUpdateEvent): void => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  return (
    <>
      <TableFilters />
      <FullWidth>
        <HeaderGridRow gridLayout={TABLE_GRID}>
          <GroupSelectCell total={totalCount} />

          {TABLE_COLS.map((col) => (
            <HeaderCell key={col.value} column={col} />
          ))}
        </HeaderGridRow>

        {views.length > 0 ? (
          <>
            {views.map((view) => (
              <ViewRow key={view.id} view={view} />
            ))}
            <PaginationFooter
              numItems={totalCount}
              currentPage={currentPage}
              itemsPerPage={size}
              onUpdate={handlePaginationUpdate}
            />
          </>
        ) : (
          <EmptyState />
        )}
      </FullWidth>
    </>
  );
};
